<template>
  <div class="welcome">
    <img src="../../assets/img/home.png" alt="Welcome!" class="welcome-img" />
  </div>
</template>
<script>
import _ from "lodash";
import { getVehiclebrandName } from "@/service";

export default {
  name: "welcome",
  created() {
    this.getVehiclebrandName();
  },
  methods: {
    // 查询品牌
    async getVehiclebrandName() {
      const res = await getVehiclebrandName();
      let data = _.get(res, "data.data");
      if (Array.isArray(data)) {
        // 适配两套组件避免多次处理数据，统一在这里处理
        data = data.map((item) => ({
          ...item,
          text: item.brandName,
          label: String(item.brandCode),
          brandCode: String(item.brandCode),
        }));
        this.$store.commit("SET_BRABNS", data);
      } else {
        this.$store.commit("SET_BRABNS", []);
      }
    },
  },
};
</script>
<style>
.welcome {
  top: 0;
}

.welcome-img {
  width: 100%;
}
</style>
